import { render, staticRenderFns } from "./RDRefillFeaturesPopup.vue?vue&type=template&id=f0f4ab4a&"
import script from "./RDRefillFeaturesPopup.vue?vue&type=script&lang=ts&"
export * from "./RDRefillFeaturesPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCardSection});
